import getStore from '../store/store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

// Threshold at which we want to show spotlight rollup
const ROLLUP_THRESHOLD = 2;

export default function shouldShowSpotlightRollup(
    unseenCount: number,
    previousRowKey: string,
    folderId: string
): boolean {
    if (getStore().rollupDismissed) {
        return false;
    }

    if (unseenCount < ROLLUP_THRESHOLD) {
        return false;
    }

    const isInboxSelected = folderId === folderNameToId('inbox');
    if (!isInboxSelected) {
        return false;
    }

    if (previousRowKey !== null) {
        return false;
    }

    return true;
}
